<template>
  <div class="faq">
    <div class="faq-question-s" v-b-toggle.q62>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q62.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q62')}}</b-col>
      </b-row>
      <b-collapse id="q62">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A62.</b></b-col>
          <b-col cols="11">
            <div>{{ $t("a62-1") }}</div>
            <b-row>
              <b-col cols="10">
                <b-table :items="items62" thead-class="hidden_header" style="background-color:white" bordered />
              </b-col>
            </b-row>
            <br />
            <div>{{ $t("a62-6") }}</div>
            <div v-html="$t('a62-7')"></div>
            <b-row>
              <b-col cols="10">
                <b-list-group>
                  <b-list-group-item>{{ $t("a62-8") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-9") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-10") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-11") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-12") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-13") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-14") }}</b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
            <br />
            <div v-html="$t('a62-15')"></div>
            <b-row>
              <b-col cols="10">
                <b-list-group>
                  <b-list-group-item>{{ $t("a62-16") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-17") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-18") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-19") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-20") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-21") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-22") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-23") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a62-24") }}</b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
            <br />
            <div>{{ $t("a62-25") }}</div>
            <br />
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q63>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q63.</b></b-col>
        <b-col cols="11" class="bd-blue">{{ $t("q63") }}</b-col>
      </b-row>
      <b-collapse id="q63">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A63.</b></b-col>
          <b-col cols="11">
            <div>{{ $t("a63-1") }}</div>
            <br />
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q64>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q64.</b></b-col>
        <b-col cols="11" class="bd-blue">{{ $t("q64") }}</b-col>
      </b-row>
      <b-collapse id="q64">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A64.</b></b-col>
          <b-col cols="11">
            <div>{{ $t("a64-1") }}</div>
            <b-row>
              <b-col cols="10">
                <b-list-group>
                  <b-list-group-item>{{ $t("a64-2") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a64-3") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a64-4") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a64-5") }}</b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
            <br />
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q65>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q65.</b></b-col>
        <b-col cols="11" class="bd-blue">{{ $t("q65") }}</b-col>
      </b-row>
      <b-collapse id="q65">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A65.</b></b-col>
          <b-col cols="11">
            <div>{{ $t("a65-1") }}</div>
            <br />
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q66>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q66.</b></b-col>
        <b-col cols="11" class="bd-blue">{{ $t("q66") }}</b-col>
      </b-row>
      <b-collapse id="q66">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A66.</b></b-col>
          <b-col cols="11">
            <b-row>
              <b-col cols="10">
                <b-list-group>
                  <b-list-group-item>{{ $t("a66-1") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a66-2") }}</b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
            <br />
            <div>{{ $t("a66-3") }}</div>
            <b-row>
              <b-col cols="10">
                <b-table :items="items66" thead-class="hidden_header" style="background-color:white;" class="test"
                  bordered />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q67>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q67.</b></b-col>
        <b-col cols="11" class="bd-blue">{{ $t("q67") }}</b-col>
      </b-row>
      <b-collapse id="q67">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A67.</b></b-col>
          <b-col cols="11">
            <div>{{ $t("a67-1") }}</div>
            <br />
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q68>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q68.</b></b-col>
        <b-col cols="11" class="bd-blue">{{ $t("q68") }}</b-col>
      </b-row>
      <b-collapse id="q68">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A68.</b></b-col>
          <b-col cols="11">
            <div><u>{{ $t("a68-1") }}</u></div>
            <div>{{ $t("a68-2") }}</div>
            <br />
            <div><u>{{ $t("a68-3") }}</u></div>
            <div>{{ $t("a68-4") }}</div>
            <br />
            <div><u>{{ $t("a68-5") }}</u></div>
            <div>{{ $t("a68-6") }}</div>
            <br />
            <div><u>{{ $t("a68-7") }}</u></div>
            <div>{{ $t("a68-8") }}</div>
            <br />
            <div><u>{{ $t("a68-9") }}</u></div>
            <div>{{ $t("a68-10") }}</div>
            <br />
            <div>{{ $t("a68-11") }}</div>
            <br />
            <div><u>{{ $t("a68-12") }}</u></div>
            <div>{{ $t("a68-13") }}</div>
            <div>{{ $t("a68-14") }}</div>
            <div>{{ $t("a68-15") }}</div>
            <br />
            <div><u>{{ $t("a68-16") }}</u></div>
            <div>{{ $t("a68-17") }}</div>
            <span class="bd-url" @click="redirectPage()">{{ this.$i18n.locale === 'en' ?
              'https://www.gov.hk/en/about/helpdesk/softwarerequirement/hkscs.htm' : this.$i18n.locale === 'zh_hk' ?
                'https://www.gov.hk/tc/about/helpdesk/softwarerequirement/hkscs.htm' :
                'https://www.gov.hk/sc/about/helpdesk/softwarerequirement/hkscs.htm' }}</span>
            <br />
          </b-col>
        </b-row>
      </b-collapse>
    </div>

  </div>
</template>

<script>
export default {
  computed: {
    items62() {
      return [
        {
          first_col: this.$t('a62-2'),
          last_col: this.$t('a62-3')
        },
        {
          first_col: this.$t('a62-4'),
          last_col: this.$t('a62-5')
        },
      ]
    },
    items66() {
      return [
        {
          first_col: this.$t('a66-4'),
          last_col: this.$t('a66-5')
        },
        {
          first_col: this.$t('a66-6'),
          last_col: this.$t('a66-7')
        },
        {
          first_col: this.$t('a66-8'),
          last_col: this.$t('a66-9')
        },
        {
          first_col: this.$t('a66-10'),
          last_col: ''
        },
      ]
    }
  },
  methods: {
    redirectPage(num) {
      switch (this.$i18n.locale) {
        case 'en':
          window.open('https://www.gov.hk/en/about/helpdesk/softwarerequirement/hkscs.htm');
          break;
        case 'zh_hk':
          window.open('https://www.gov.hk/tc/about/helpdesk/softwarerequirement/hkscs.htm');
          break;
        case 'zh_cn':
          window.open('https://www.gov.hk/sc/about/helpdesk/softwarerequirement/hkscs.htm')
      }
    },
    processAllTables() {
      const tables = document.querySelectorAll('table');
      let elementFound = false;

      tables.forEach(table => {
        // 處理每個表格中的所有元素
        const trElements = table.querySelectorAll('tr');
        const thElements = table.querySelectorAll('th');
        const tdElements = table.querySelectorAll('td');

        if (trElements.length > 0 || thElements.length > 0 || tdElements.length > 0) {
          elementFound = true;
          trElements.forEach(tr => tr.removeAttribute('role'));
          thElements.forEach(th => th.removeAttribute('role'));
          tdElements.forEach(td => td.removeAttribute('role'));
        }
      });
      return elementFound;
    },
    startProcessing() {
      this.checkInterval = setInterval(() => {
        this.currentAttempt++;
        
        if (this.processAllTables()) {
          clearInterval(this.checkInterval);
        } else if (this.currentAttempt >= this.maxAttempts) {
          clearInterval(this.checkInterval);
        }
      }, 500);
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.startProcessing();
    })
  },
  beforeDestroy() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .hidden_header {
  display: none;
}
</style>

<i18n src="@/public/locales/modules/faq/components/FaqSystem.json" />